import { groupBy } from 'lodash';
import { User } from '@lgg/isomorphic/types/__generated__/graphql';
import { userToSelectOptionMapper } from 'src/components/general/inputs/select/mappers/user-to-select-option-mapper';

export const getSortedUserSelectOptions = (users: User[]) => {
  return users
    .map(userToSelectOptionMapper)
    .sort((a, b) => a.label.localeCompare(b.label));
};

// Buckets users by role id: the agent role first, then other company roles, then
// everything else, each translated and alphabetized within its bucket.
export const groupByRoleId = (
  users: User[],
  t: (key: string) => string,
): { label: string; items: User[] }[] => {
  const itemsByRole = groupBy(users, (user) => user.role.id);
  const roles = Object.keys(itemsByRole).sort((a, b) => a.localeCompare(b));

  const groupedRoles = groupBy(roles, (role) => {
    if (role === 'company.agent') {
      return 'companyAgentRole';
    } else if (role.includes('company')) {
      return 'companyRoles';
    } else {
      return 'others';
    }
  });

  const sortedRoles = [
    ...(groupedRoles['companyAgentRole'] ?? []),
    ...(groupedRoles['companyRoles'] ?? []),
    ...(groupedRoles['others'] ?? []),
  ];

  return sortedRoles.map((role) => ({
    label: t(`common:roles.${role}`),
    items: itemsByRole[role],
  }));
};
